import { getAnalyticsClickHandler } from '@eventbrite/legacy-infra.site-analytics';
import { defineMessage } from 'react-intl';
import {
    ACTION_LOGIN_HOVER,
    ACTION_SIGNIN_CLICK,
    ACTION_SIGNUP_CLICK,
    CATEGORY_HEADER,
} from '../constants/tracking';

/**
 * Gets list of links usually passed as `nonUserQuickLinks` prop to EDS Global Header
 * @param {string} [requestPath] Current request path (for analytics)
 * @param {boolean} [isAuthenticated] Whether or not the user is authenticated
 * @param {string} loginUrl URL to the sign-in page
 * @param {string} signupUrl URL to the sign-up page
 * @param {object} [options] Additional options
 * @param {boolean} [options.launchNewSignInSignUpLinks] Whether to use new sign in/sign up links
 * @returns object[]
 */
export const getNonUserQuickLinks = (
    requestPath,
    isAuthenticated,
    loginUrl,
    signupUrl,
    { launchNewSignInSignUpLinks = false } = {},
) => {
    if (isAuthenticated) {
        return null;
    }
    const loginAction = ACTION_SIGNIN_CLICK;
    const signupAction = ACTION_SIGNUP_CLICK;
    let loginLink = {
        url: loginUrl,
        content: defineMessage({ id: 'Sign In', defaultMessage: 'Sign In' }),
        onClick: getAnalyticsClickHandler({
            requestPath,
            action: loginAction,
            category: CATEGORY_HEADER,
        }),
    };
    let signupLink = [];

    loginLink = {
        ...loginLink,
        onMouseLeave: getAnalyticsClickHandler({
            requestPath,
            action: ACTION_LOGIN_HOVER,
            category: CATEGORY_HEADER,
        }),
    };
    if (launchNewSignInSignUpLinks) {
        loginLink = {
            ...loginLink,
            content: defineMessage({ id: 'Log In', defaultMessage: 'Log In' }),
            onClick: getAnalyticsClickHandler({
                requestPath,
                action: ACTION_SIGNIN_CLICK,
                category: CATEGORY_HEADER,
            }),
        };
        signupLink = [
            {
                url: signupUrl,
                content: defineMessage({ id: 'Sign Up', defaultMessage: 'Sign Up' }),
                onClick: getAnalyticsClickHandler({
                    requestPath,
                    action: signupAction,
                    category: CATEGORY_HEADER,
                }),
            },
        ];
    }

    return [loginLink, ...signupLink];
};
